import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import ITModLayout from "../../components/itmodlayout"
import SEO from "../../components/seo"

import "../../style/main.scss"

import SubNav from "../../components/subnav"
import WrapAbout from "../../components/aboutwrap"
import Location from "../../components/location"

import styles from "./wrap.module.css"

import wimg1 from "./SNG4.png"
import wimg2 from "./SNG2.png"
import wimg3 from "./SNG1.png"
import wimg4 from "./SNG3.png"

const IndexPage = () => {

        const data = useStaticQuery(graphql`
        query {
          site {
            siteMetadata {
              speakers {
                name
                title
                image
                disabledProfile
                event
              }
              sponsorshipLevel
              sponsors {
                name
                level
                logo
                url
                width
                event
              }
              sessions {
                startTime
                endTime
                title
                description
                type
                speakers {
                  name
                  isModerator
                }
                event
              }
            }
          }
        }
      `)
  
    const {
      speakers,
      sessions,
      sponsors,
      sponsorshipLevel
    } = data.site.siteMetadata

  return (
    <ITModLayout>
      <SEO title="IT Modernization Live 2020 | Wrap Up" />
      <SubNav />
      <WrapAbout sponsors={sponsors} sponsorshipLevel={sponsorshipLevel} />
      
      <section className={styles.blurb} id="blurb">
            
            <div className={styles.gridContainwrap}>
                
                
                <div className={styles.gridUp}>

                  <div className={styles.storyblock}>
                          
                          <img src={wimg1}  />
                          
                  </div>

                  <div className={styles.storyblock}>
                      
                          <img src={wimg2}  />
                          
                  </div>

                  <div className={styles.storyblock}>
                      
                          <img src={wimg3}  />
                      
                  </div>

                  <div className={styles.storyblock}>
                      
                          <img src={wimg4}  />
                          
                  </div>
                </div>
                <br /><br />
            </div>
            
  </section>
    </ITModLayout>
  )
}

export default IndexPage